export default "__VITE_ASSET__fa79701e__"